var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultHorse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24x24px/Result_horse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/24x24px/Result_horse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/betslip",
    transform: "translate(3.500000, 2.250000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,0.5 L4.5,1.5 C4.5,1.74136889 4.54275711,1.97275132 4.62111035,2.1869863 L1.90298507,2.18674699 C1.8329191,2.18674699 1.7761194,2.24068858 1.7761194,2.30722892 L1.7761194,18.6927711 C1.7761194,18.7593114 1.8329191,18.813253 1.90298507,18.813253 L15.0970149,18.813253 C15.1670809,18.813253 15.2238806,18.7593114 15.2238806,18.6927711 L15.2238806,2.30722892 C15.2238806,2.24068858 15.1670809,2.18674699 15.0970149,2.18674699 L12.3788897,2.1869863 C12.4572429,1.97275132 12.5,1.74136889 12.5,1.5 L12.5,0.5 L15.0970149,0.5 C16.1480046,0.5 17,1.30912395 17,2.30722892 L17,18.6927711 C17,19.6908761 16.1480046,20.5 15.0970149,20.5 L1.90298507,20.5 C0.851995439,20.5 0,19.6908761 0,18.6927711 L0,2.30722892 C0,1.30912395 0.851995439,0.5 1.90298507,0.5 L4.5,0.5 Z",
    id: "Combined-Shape",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0 C9.49814383,0 10.3596642,0.561556241 10.7604539,1.37352571 L12.5,1.37323034 L12.5,3.35 C12.5,4.4545695 11.6045695,5.35 10.5,5.35 L6.5,5.35 C5.3954305,5.35 4.5,4.4545695 4.5,3.35 L4.5,1.37323034 L6.23954611,1.37352571 C6.64033577,0.561556241 7.50185617,0 8.5,0 Z",
    id: "Combined-Shape",
    stroke: "#333333",
    strokeWidth: 1.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Oval",
    stroke: "#333333",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Oval",
    stroke: "#333333",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Oval",
    stroke: "#333333",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 12.25,
    x2: 15.5,
    y2: 12.25,
    id: "Line-2",
    stroke: "#333333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 14.75,
    x2: 15.5,
    y2: 14.75,
    id: "Line-2",
    stroke: "#333333",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 17.25,
    x2: 15.5,
    y2: 17.25,
    id: "Line-2",
    stroke: "#333333",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultHorse);
export default __webpack_public_path__ + "static/media/result_horse.b990f3e180ce5fd85b134200c4b070ba.svg";
export { ForwardRef as ReactComponent };